module.exports = __webpack_public_path__ + "img/workflow-icon-new-light.d2e191bc.svg";